// extracted by mini-css-extract-plugin
export default {"dealerGroupEditorDialogContainer":"_dealer-group-editor-dialog_dealerGroupEditorDialogContainer__vfq8X"};